module.exports = {
      id: "rain-usage",
      viewBox: "0 0 38.4 27.718",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#rain",
      toString: function () {
        return this.url;
      }
    }